import React, { forwardRef, isValidElement } from "react";

import styled, { css } from "styled-components";
import { Whisper as RsuiteWhisper } from "rsuite";

const Whisper = forwardRef(({
    children,
    trigger,
    targetClassName,
    targetProps = {},
    targetStyle,
    inheritChildClassName = true,
    absolute = false,
    coverTarget = false,
    ...props
}, ref) => {
    const childClassName = inheritChildClassName && isValidElement(children) ? children.props.className : null;
    const resolvedTargetClassName = [targetClassName, childClassName]
        .filter(Boolean)
        .join(" ") || undefined;
    const focusableTarget = Array.isArray(trigger)
        ? trigger.includes("focus")
        : trigger === "focus";

    return (
        <RsuiteWhisper
            {...props}
            trigger={trigger}
            ref={ref}
        >
            <WhisperTarget
                {...targetProps}
                className={resolvedTargetClassName}
                tabIndex={targetProps.tabIndex ?? (focusableTarget ? 0 : undefined)}
                style={targetStyle}
                absolute={absolute}
                coverTarget={coverTarget}
            >
                {children}
            </WhisperTarget>
        </RsuiteWhisper>
    );
});

export default Whisper;

const WhisperTargetBase = forwardRef(({ absolute, coverTarget, ...props }, ref) => (
    <span ref={ref} {...props} />
));

export const WhisperTarget = styled(WhisperTargetBase)`
    align-items: center;
    cursor: help;
    display: inline-flex;
    justify-content: center;
    line-height: 1;

    ${props => props.coverTarget && css`
        bottom: 0;
        height: 100%;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
        z-index: 10000;
    `}
`;
